/* eslint-disable max-len */
import React from "react";


export default function StatsIcon(): JSX.Element {
    return (
        <svg width="77" height="76" viewBox="0 0 77 76" fill="white" xmlns="http://www.w3.org/2000/svg">
            <path d="M61.5 26.5C70.6716 24.375 73.1708 21.8495 75 16V2H61.5M61.5 26.5V35.5C54.4052 49.7315 49.1478 51.2192 39.5 52.5M61.5 26.5V2M16 26.5C7.37212 24.5841 4.34156 22.2675 2 16V2H16M16 26.5V2M16 26.5V35.5C20.9677 47.8934 25.9145 51.7602 39.5 52.5M16 2H61.5M39.5 52.5V63.5M39.5 63.5H23.5V74.5H54.5V63.5H39.5Z" stroke="#BDBDBD" strokeWidth="2.5" />
        </svg>
    );
}
